import React from "react";

const variantClasses = {
  default: "bg-white text-slate-950 dark:bg-slate-950 dark:text-white",
  soft: "bg-slate-50 text-slate-950 dark:bg-slate-900 dark:text-white",
  dark: "bg-slate-950 text-white",
};

const PublicSection = ({
  id,
  eyebrow,
  title,
  subtitle,
  children,
  variant = "default",
  className = "",
}) => {
  return (
    <section
      id={id}
      className={`
        relative w-full max-w-full overflow-x-clip scroll-mt-32
        px-4 py-16 sm:px-6 sm:py-20 lg:px-8 lg:py-24
        ${variantClasses[variant] || variantClasses.default}
        ${className}
      `}
    >
      <div className="mx-auto w-full max-w-[1380px] min-w-0 overflow-x-clip">
        {(eyebrow || title || subtitle) && (
          <div className="mx-auto mb-10 w-full max-w-4xl min-w-0 text-center">
            {eyebrow && (
              <p className="break-words text-xs font-bold uppercase tracking-[0.22em] text-orange-600 dark:text-orange-300 sm:tracking-[0.26em]">
                {eyebrow}
              </p>
            )}

            {title && (
              <h2 className="mt-3 break-words text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
                {title}
              </h2>
            )}

            {subtitle && (
              <p
                className={`mx-auto mt-4 max-w-3xl break-words text-base leading-relaxed sm:text-lg ${
                  variant === "dark"
                    ? "text-slate-300"
                    : "text-slate-600 dark:text-slate-300"
                }`}
              >
                {subtitle}
              </p>
            )}
          </div>
        )}

        <div className="w-full max-w-full min-w-0 overflow-x-clip">
          {children}
        </div>
      </div>
    </section>
  );
};

export default PublicSection;